import React, { useState } from "react";

type StarRatingProps = {
  value: number;
  onChange: (rating: number) => void;
  totalStars: number;
  starImage?: string;
};

const StarRating: React.FC<StarRatingProps> = ({
  value,
  onChange,
  totalStars,
  starImage,
}) => {
  const [hover, setHover] = useState(0);
  const basePath = process.env.PUBLIC_URL;

  // Responsive star size
  const starSize = "clamp(36px, 8vw, 60px)";

  return (
    <div
      className="theme-text-color"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        zIndex: 10,
        padding: "0 12px",
      }}
    >
      {/* Responsive heading */}
      <h1
        style={{
          fontSize: "clamp(18px, 5vw, 28px)",
          textAlign: "center",
          marginBottom: "12px",
        }}
      >
        Rate your experience
      </h1>

      {/* Stars container */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        {Array.from({ length: totalStars }, (_, i) => i + 1).map(
          (star: any) => {
            const isActive = star <= value || (hover >= star && star > value);

            return (
              <span
                key={star}
                onClick={() => onChange(star)}
                onMouseEnter={() => star > value && setHover(star)}
                onMouseLeave={() => setHover(0)}
                style={{
                  cursor: "pointer",
                  width: starSize,
                  height: starSize,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {isActive ? (
                  <img
                    src={starImage || `${basePath}/images/selected-star.png`}
                    alt="selected star"
                    style={{
                      width: starSize,
                      height: starSize,
                    }}
                  />
                ) : (
                  <span
                    style={{
                      fontSize: starSize,
                      color: "#ccc",
                      lineHeight: 1,
                    }}
                  >
                    ★
                  </span>
                )}
              </span>
            );
          },
        )}
      </div>
    </div>
  );
};

export default StarRating;
